import { useParams } from "react-router-dom";
import { useSelectedOrganization } from "../../../organizations/hooks";
import { GlobalLensDetails } from "../components";
import { useLensDetailsV2 } from "../hooks";
import { useGroupInfo } from "../../../groups/hooks";
import { LenssourceModelLensSourceType as LensSourceType } from "../../../../gql-generated/types";
import { AbsoluteRoute, type RouteParams } from "../../../../core/routes";

export const GlobalLensDetailsContainerV2 = () => {
    const { orgId, lensId, groupId, lensSourceType, reference } =
        useParams<RouteParams[AbsoluteRoute.ORG_LENS_SCHEDULER_GROUP_LENS]>();

    const { selectedOrganizationId, loading: orgIsLoading, permissions } = useSelectedOrganization();
    const organizationId = orgId ?? selectedOrganizationId ?? "";
    const groupInfo = useGroupInfo(groupId ?? "");
    const {
        lensDetails,
        loading,
        saveLensDetails,
        saveInProgress,
        globalVendorData,
        changeGlobalVendorData,
        changeLensInGroupVendorData,
        changeSchedule,
        addGroups,
        removeGroup,
        isError,
    } = useLensDetailsV2(
        {
            id: lensId ?? "",
            lensSourceType: lensSourceType as LensSourceType,
            reference: reference ?? "",
        },
        organizationId,
    );

    return (
        <GlobalLensDetails
            group={groupInfo}
            lensGroups={lensDetails}
            loading={loading || orgIsLoading}
            saveInProgress={saveInProgress}
            globalVendorData={globalVendorData}
            onGlobalVendorDataChanged={changeGlobalVendorData}
            onLensInGroupVendorDataChanged={changeLensInGroupVendorData}
            organizationId={organizationId}
            lens={lensDetails.lens}
            onSave={saveLensDetails}
            onAddLensToGroups={addGroups}
            onScheduleChanged={changeSchedule}
            onRemoveFromGroup={removeGroup}
            isError={isError}
            permissions={permissions}
        />
    );
};
